export interface ISubscription {
  id: string;
  name: string;
  durationType: SubscriptionDurationTypesEnum;
  duration: number;
  isVisible: boolean;
  price: number;
  description: string;
  credits: number;
  creditsRolloverAmount: number;
  isDeleted?: boolean;
  stripeProductId: string;
  stripePriceId: string;
  createdAt: Date;
  updatedAt: Date;
}

export enum SubscriptionDurationTypesEnum {
  day = "day",
  week = "week",
  month = "month",
  year = "year",
}
